import { render, staticRenderFns } from "./CollaboratorCreate.vue?vue&type=template&id=590a308e&scoped=true&"
import script from "./CollaboratorCreate.vue?vue&type=script&lang=js&"
export * from "./CollaboratorCreate.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorCreate.vue?vue&type=style&index=0&id=590a308e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590a308e",
  null
  
)

export default component.exports